<template>
  <div class="layout-wrapper layout-2">
    <div class="layout-inner">
      <app-layout-sidenav />

      <div class="layout-container">
        <app-layout-navbar />

        <div class="layout-content">
          <div class="router-transitions container-fluid flex-grow-1 container-p-y">
            <router-tab :class="{ 'is-fullscreen': fullscreen }" page-transition="page-fade" tab-transition="tab-scale">
              <template #start>
                <router-link
                  class="tab-slot-icon rt-icon-home"
                  to="/slot/"
                  title="首页"
                />
              </template>
              <template #end>
                <a
                  class="tab-slot-icon rt-icon-fullscreen"
                  :title="fullscreen ? '退出全屏' : '全屏'"
                  @click="fullscreen = !fullscreen"
                />
              </template>
              <template #default="tab">
                <i v-if="tab.icon" class="tab-icon" :class="tab.icon" />
                <span class="badge badge-dot badge-default"></span>
                <span class="tab-title" :title="tab.tips">{{ tab.title }}</span>
                <i v-if="tab.closable" class="tab-close" @click.prevent="tab.close" />
              </template>
            </router-tab>
            <!-- <router-tab /> -->
          </div>

          <app-layout-footer />
        </div>
      </div>
    </div>
    <div class="layout-overlay" @click="closeSidenav"></div>
  </div>
</template>

<script>
import LayoutNavbar from './LayoutNavbar'
import LayoutSidenav from './LayoutSidenav'
import LayoutFooter from './LayoutFooter'

export default {
  name: 'app-layout-2',
  data () {
    return {
      classCheck: true,
      fullscreen: false
    }
  },
  components: {
    'app-layout-navbar': LayoutNavbar,
    'app-layout-sidenav': LayoutSidenav,
    'app-layout-footer': LayoutFooter
  },
  mounted () {
    this.layoutHelpers.init()
    this.layoutHelpers.update()
    this.layoutHelpers.setAutoUpdate(true)
  },

  beforeDestroy () {
    this.layoutHelpers.destroy()
  },

  methods: {
    closeSidenav () {
      this.layoutHelpers.setCollapsed(true)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ {
  // 页面 fade 过渡
  .page-fade {
    &-enter-active,
    &-leave-active {
      transition: opacity 0s;
    }

    &-enter,
    &-leave-to {
      opacity: 0;
    }
  }

  // 页签 scale 过渡
  .tab-scale {
    &-enter-active,
    &-leave-active{
      transition: opacity 0s, transform 0s;
    }

    &-enter,
    &-leave-to {
      opacity: 0;
      transform: scale(0);
    }
  }
}
</style>
<style scoped>

</style>
<style lang="scss" scoped>

// 全屏
.router-tab.is-fullscreen {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  background: #fff;
}

// 页签前后插槽样式
.router-tab /deep/ {
  .router-tab_start,
  .router-tab_end {
    display: flex;
    align-items: center;
  }
}

.tab-slot-icon {
  color: #2c3e50;
  font-size: 20px;
  text-decoration: none;
  cursor: pointer;

  &:active {
    opacity: 0.8;
  }
}
</style>
